import "./Sustainability.css";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import csr_business_conduct from "../../assets/images/csr_business_conduct.webp";
import csr_safety from "../../assets/images/csr_safety.webp";
import img1_2 from "../../assets/images/img1-2.webp";
import img2_1 from "../../assets/images/img2-1.webp";
import img3_1 from "../../assets/images/img3-1.webp";

function Sustainability() {
  return (
    <div>
      <Header />
      <div className="sustainabity__main">
        <section className="contact__main__section__one bgcsr">
          <h1>Corporate Social Responsibility</h1>
        </section>
        <section className="sustainability__main__section__two">
          <h1>Our Sustainable Approach</h1>
          <hr />
          <h3>
            At GuineGulf Energy, sustainability is at the core of everything we
            do. We are committed to advancing the transition to a low-carbon
            future, minimizing environmental impact, and promoting social
            responsibility across all aspects of our business operations.
          </h3>
          <p>
            Through strategic initiatives, innovative technologies, and
            responsible practices, we strive to create lasting value for our
            stakeholders while safeguarding the planet for future generations.
          </p>
        </section>
        <section className="sustainability__main__section__three">
          <img src={csr_business_conduct} alt="" />
          <div>
            <h1>Environmental Stewardship</h1>
            <hr />
            <h3>
              We recognize the importance of protecting the environment and
              minimizing our carbon footprint.
            </h3>
            <p>
              Through the adoption of cleaner energy technologies, energy
              efficiency measures, and emission reduction strategies, we are
              actively working to mitigate climate change and preserve natural
              resources for future generations.
            </p>
          </div>
        </section>
        <section className="sustainability__main__section__four">
          <img src={csr_safety} alt="" />
          <div>
            <h1>Health and Safety</h1>
            <hr />
            <p>
              The safety and well-being of our employees, contractors, and
              communities are our top priorities. We maintain rigorous safety
              standards, provide comprehensive training programs, and implement
              robust health and safety protocols to ensure a safe working
              environment for everyone involved in our operations.
            </p>
          </div>
        </section>
        <section className="sustainability__main__section__three">
          <img src={img1_2} alt="" />
          <div>
            <h1>Community Engagement</h1>
            <hr />
            <p>
              We believe in fostering strong relationships with the communities
              where we operate, respecting local customs and traditions, and
              contributing to socio-economic development. We actively engage
              with stakeholders to understand their needs, address concerns, and
              create shared value through meaningful partnerships and
              initiatives.
            </p>
          </div>
        </section>
        <section className="sustainability__main__section__four">
          <img src={img3_1} alt="" />
          <div>
            <h1>Ethical Business Practices</h1>
            <hr />
            <p>
              Integrity, transparency, and accountability are the cornerstones
              of our business philosophy. We adhere to the highest ethical
              standards in all our dealings, comply with applicable laws and
              regulations, and uphold the principles of fairness and integrity
              in our relationships with customers, suppliers, and partners.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default Sustainability;
